import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getSitePaymentMethodTypeRequest = {};
var _getSitePaymentMethodTypeResponse = {};
var _listSitePaymentMethodTypesRequest = {};
var _listSitePaymentMethodTypesResponse = {};
function resolveWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodTypeServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/payment-method-types',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/payments/site-payment-method-types',
                destPath: '',
            },
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'cashier._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'cashier.wixapps.net': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'cashier-services._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'events._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'invoices._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'pricing-plans.wixapps.net': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'vod-server._base_domain_': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'www.wixhotels.com': [
            {
                srcPath: '/_api/payment-method-types',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'tpa.wixapps.net': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/payments/payment-method-types',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/payments/site-payment-method-types/v1/site-payment-method-types',
                destPath: '/v1/site-payment-method-types',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/payments/site-payment-method-types/v1/site-payment-method-types',
                destPath: '/v1/site-payment-method-types',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a payment method type, with some fields localized according to the caller's language and country.
 *
 * The callers language and country are taken from the `languageCode` or `countryCode` parameters in the request.
 * If these parameters are not specified, the values are taken from context of the call if possible. For example, if this method is called from a Wix site, the selected language on that site will be used.
 * If language or country can't be determined, the method doesn't perform any filtering or localization.
 *
 * Language and country are used to determine localized values for the `displayName`, `description` fields.
 * Country is used to determine localized values for the `priority` and `promoted` fields in `merchantFlow` and `buyerFlow`.
 * `currencyCode` is used to determine the eligibility of payment method types for the provided currency.
 */
export function getSitePaymentMethodType(payload) {
    var _a = serializer(_getSitePaymentMethodTypeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSitePaymentMethodTypeResponse, {}).fromJSON;
    function __getSitePaymentMethodType(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.site_payment_method_types.v1.site_payment_method_type',
            method: 'GET',
            methodFqn: 'wix.payments.site_payment_method_types.v1.SitePaymentMethodTypeService.GetSitePaymentMethodType',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodTypeServiceUrl({
                protoPath: '/v1/site-payment-method-types/{sitePaymentMethodTypeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSitePaymentMethodType.fromReq = fromReq;
    __getSitePaymentMethodType.__isAmbassador = true;
    return __getSitePaymentMethodType;
}
/**
 * Retrieves a list of payment method types.
 *
 * If an `ids` array is specified, only payment method types with matching IDs or legacy IDs are returned.
 * If no `ids` are specified, all payment method types available in the caller's country are returned, with some fields localized according to the caller's language and country.
 *
 * The caller's language and country are taken from the `languageCode` or `countryCode` parameters in the request.
 * If `languageCode` or `countryCode` are not specified, the values are taken from context of the call if possible. For example, if this method is called from a Wix site, the selected language on that site will be used.
 * If language or country can't be determined, the method doesn't perform any filtering or localization.
 *
 * Language and country are used to determine localized values for the `displayName`, `description` fields.
 * Country is used to determine localized values for the `priority` and `promoted` fields in `merchantFlow` and `buyerFlow`.
 * `currencyCode` is used to determine the eligibility of payment method types for the provided currency.
 */
export function listSitePaymentMethodTypes(payload) {
    var _a = serializer(_listSitePaymentMethodTypesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSitePaymentMethodTypesResponse, {}).fromJSON;
    function __listSitePaymentMethodTypes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.site_payment_method_types.v1.site_payment_method_type',
            method: 'GET',
            methodFqn: 'wix.payments.site_payment_method_types.v1.SitePaymentMethodTypeService.ListSitePaymentMethodTypes',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodTypeServiceUrl({
                protoPath: '/v1/site-payment-method-types',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSitePaymentMethodTypes.fromReq = fromReq;
    __listSitePaymentMethodTypes.__isAmbassador = true;
    return __listSitePaymentMethodTypes;
}
//# sourceMappingURL=http.impl.js.map